export default __webpack_public_path__ + "static/media/scheduling-top-banner.4794d3bc.png";